import { useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap'
import constants from "../../../contants"
import FAQ from '../faq';
import Contact from '../contact-form'
import Footer from '../../common/footer'
// import Footer from '../../component/common/footer'
import SEO from '../../util/SEO';
import './projectBody.css'
import './visualSection.css'
const { projects } = constants

function ProjectBody() {
    const { id } = useParams();
    let project;
    for (let index = 0; index < projects.length; index++) {
        if (projects[index].id === id) {
            project = projects[index];
            break;
        }
    }
    if (!project) {
        return (
            <section className="project-body" aria-labelledby="project-not-found-heading">
                <SEO
                    title="Case Study Not Found"
                    description="The requested BringIt Go case study could not be found."
                    canonical={`https://www.bringitgo.tech/project/${id || ''}`}
                    robots="noindex, follow"
                />
                <Row className='justify-content-center'>
                    <Col mx='auto'>
                        <h1 id="project-not-found-heading" className='project-name'>Case study not found</h1>
                        <p className='portfolio-description'>Explore our portfolio to find current BringIt Go case studies.</p>
                        <a href="/portfolio" className="btn btn-light mt-3">View portfolio</a>
                    </Col>
                </Row>
            </section>
        );
    }
    const projectSchema = {
        '@context': 'https://schema.org',
        '@type': 'CreativeWork',
        headline: `${project.Name} Case Study`,
        name: project.Name,
        description: project.Description,
        image: project.Image,
        url: `https://www.bringitgo.tech/project/${project.id}`,
        creator: {
            '@type': 'Organization',
            name: 'BringIt Go',
            url: 'https://www.bringitgo.tech',
        },
        about: Array.isArray(project.Category) ? project.Category.join(', ') : project.Category,
    };

    return (
        <>
        <main className="project-body" aria-label="Case study details">
            <SEO
                title={`${project.Name} - ${project.Subtitle || 'Web Services Case Study'} | BringIt Go`}
                description={`${project.Name} Case Study by BringIt Go. Discover how we built custom web solutions for this ${project.Industry || 'organization'}.`}
                canonical={`https://www.bringitgo.tech/project/${project.id}`}
                image={project.Image}
                type="article"
                keywords={`${project.Name} case study, bringitgo tech, ${project.Company || 'business integration'}, ${Array.isArray(project.Category) ? project.Category.join(', ') : project.Category}`}
                structuredData={projectSchema}
            />
            
            {/* <Row className='justify-content-center'>
                <Col mx='auto'>
                    <h1 id="project-heading" className='project-name'>{project.Name}</h1>
                    <p className='portfolio-description'>{project.Description}</p>
                </Col>
            </Row> */}
            <header className="project-hero" aria-labelledby="project-header">
                <Row className="align-items-center">
                    <Col lg={7} md={12}>
                        <span className="hero-tagline">{project.Industry || "Web Services & Development"}</span>
                        <h1 id="project-heading" className='project-name'>{project.Name}</h1>
                        {project.Subtitle && <p className="project-subtitle-text">{project.Subtitle}</p>}
                        
                        {project.Tags && (
                          <div className="hero-tags-wrapper">
                            {project.Tags.map((tag, i) => (
                              <span key={i} className="seo-badge">{tag}</span>
                            ))}
                          </div>
                        )}
                    </Col>
                    <Col lg={5} md={12} className="mt-4 mt-lg-0">
                        {/* SIDEBAR: Project Snapshot metadata block */}
                        <aside className="project-metadata-card">
                            <h2 className="visually-hidden">Project Overview Metadata</h2>
                            <div className="meta-row">
                                <span className="meta-label">Client Partner:</span>
                                <span className="meta-value">{project.Company}</span>
                            </div>
                            <div className="meta-row">
                                <span className="meta-label">Location:</span>
                                <span className="meta-value">{project.Location || "Global Collaboration"}</span>
                            </div>
                            <div className="meta-row">
                                <span className="meta-label">Expertise Applied:</span>
                                <span className="meta-value">
                                    {Array.isArray(project.Category) ? project.Category.join(' / ') : project.Category}
                                </span>
                            </div>
                        </aside>
                    </Col>
                </Row>
            </header>
           
            {/* VISUAL PREVIEW BLOCK */}
            {/* --- HYPER-FUTURISTIC COMMAND CENTER HUD --- */}
            <section className="project-command-hud-section">
                <div className="hud-master-console">
                    
                    {/* Quantum Backend Energy Emission Fields */}
                    <div className="hud-ambient-glow center-glow"></div>
                    <div className="hud-ambient-glow secondary-glow"></div>

                    {/* Top Console Diagnostic Ribbon */}
                    <div className="hud-top-ribbon">
                        <div className="ribbon-left-cluster">
                            <span className="hud-system-status-indicator blink-slow"></span>
                            <span className="hud-terminal-id">{project.Name}</span>
                        </div>
                      
                        <div className="ribbon-right-cluster">
                            <div className="hud-audio-waves">
                                <span></span><span></span><span></span><span></span>
                            </div>
                            <span className="hud-format-badge">
                                {project.Video ? "MP4_STREAM" : project.GIF ? "GIF_RUNTIME" : "RAW_DATA"}
                            </span>
                        </div>
                    </div>

                    {/* Interactive Vector Alignment Crosshairs */}
                    <div className="hud-sight sight-tl"></div>
                    <div className="hud-sight sight-tr"></div>
                    <div className="hud-sight sight-bl"></div>
                    <div className="hud-sight sight-br"></div>

                    {/* Main Media Deployment Deck */}
                    <div className="hud-presentation-deck">
                        <div className="hud-media-container">
                            {project.Video ? (
                                <video 
                                    className='hud-deployed-asset' 
                                    autoPlay 
                                    muted 
                                    loop 
                                    playsInline
                                    poster={project.Image}
                                >
                                    <source src={project.Video} type="video/mp4" />
                                </video>
                            ) : (
                                <img
                                    className='hud-deployed-asset'
                                    src={project.GIF ? project.GIF : project.Image}
                                    alt={`${project.Name} deployment system visualization`}
                                    loading="eager"
                                />
                            )}
                            <div className="hud-matrix-scanlines"></div>
                        </div>
                    </div>

                    {/* Bottom Telemetry Display Panel */}
                    <div className="hud-bottom-panel">
                        <div className="panel-node-block">
                            <span className="panel-title">CORE MATRIX</span>
                            <span className="panel-value">DEPLOYMENT_SUCCESSFUL</span>
                        </div>
                        <div className="panel-node-block text-end">
                            <span className="panel-title">INTERFACE STACK</span>
                            <span className="panel-value text-amber">#FF9800_SYS</span>
                        </div>
                    </div>

                </div>
            </section>
            
            {/* CASE STUDY CORE CONTENT GRID */}
            <section className="project-case-details container-fluid my-5">
                <Row className="gy-4">
                    {/* The Business Challenge Column */}
                    <Col lg={6} md={12}>
                        <div className="content-block-wrapper challenge-card">
                            <h2 className="project-section-heading">The Challenge</h2>
                            <p className="detail-text">{project.Challenge || "The client required a tailored architecture upgrade to solve critical bottleneck access speeds, update visual properties, and ensure optimal customer acquisition conversion paths."}</p>
                        </div>
                    </Col>

                    {/* The Engineered Solution Column */}
                    <Col lg={6} md={12}>
                        <div className="content-block-wrapper solution-card">
                            <h2 className="project-section-heading">Our Engineering Solution</h2>
                            <p className="detail-text">{project.Description}</p>
                        </div>
                    </Col>
                </Row>
            </section>
            <FAQ />
            <Contact />
        
        </main>
        </>
      
    )
}

export default ProjectBody
